import {combineReducers, createStore, applyMiddleware} from 'redux';
import {reducer as reduxFormReducer} from 'redux-form';
import thunkMiddleware from 'redux-thunk';

import {
    sidebarReducer,
    themeReducer,
    MainDashbaordReducer,
    SalesReducer,
    SalesItemReducer,
    CustomersReducer,
    AutoCustomersReducer,
    ChangeSimReducer,
    TasksReducer,
    ManagersStatsReducer,
    SalesStatsReducer,
    DeletedDealsReducer,
    OrdersReducer,
    EquipmentReducer,
    PrizeReducer,
    UserHistoryReducer,
    AdminReducer,
    UserDataReducer,
    ProvidersReducer,
    UtilsDataReducer
} from '../../redux/reducers/index';

const reducer = combineReducers({
    form: reduxFormReducer, // mounted under "form",
    theme: themeReducer,
    sidebar: sidebarReducer,
    mainDashboard: MainDashbaordReducer,
    sales: SalesReducer,
    providers: ProvidersReducer,
    salesItem: SalesItemReducer,
    customers: CustomersReducer,
    autoCustomers: AutoCustomersReducer,
    changeSim: ChangeSimReducer,
    tasks: TasksReducer,
    managersStats: ManagersStatsReducer,
    salesStats: SalesStatsReducer,
    deletedDeals: DeletedDealsReducer,
    orders: OrdersReducer,
    equipment: EquipmentReducer,
    prize: PrizeReducer,
    userHistory: UserHistoryReducer,
    admin: AdminReducer,
    userData:UserDataReducer,
    utilsData:UtilsDataReducer,
});

const store = (window.devToolsExtension
    ? window.devToolsExtension()(createStore)
    : createStore)(reducer,applyMiddleware(thunkMiddleware));


export default store;
